<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label
      class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUNDLAGE_VORAUSZAHLUNGEN.JAHRESUEBERSCHUSS' | translate }}</label>
    <label class="col-sm-2"></label>
    <label *ngIf="isNotSmallSize"
           class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUNDLAGE_VORAUSZAHLUNGEN.JAHRESUEBERSCHUSS' | translate }}</label>
  </div>
  <div class="form-row justify-content-between">
    <label class="d-sm-none col-form-label" for="gewinn">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUENDUNGSJAHR' | translate }}
    </label>
    <div class="col-sm-5">
      <input class="form-control text-right pr-3x" datevMessagePath="gewinn{{objectId}}" formControlName="gewinn"
             id="gewinn" type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsMarkRequired

             utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>
    <label class="d-sm-none col-form-label" for="gewinnFj">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.FOLGEJAHR' | translate }}
    </label>
    <div class="col-sm-5">
      <input class="form-control text-right pr-3x" datevMessagePath="gewinnFj{{objectId}}" formControlName="gewinnFj"
             id="gewinnFj"
             type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsMarkRequired

             utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>
  </div>

  <div class="form-row">
    <label
      class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUNDLAGE_VORAUSZAHLUNGEN.ZU_VERSTEUERNDES_EINKOMMEN' | translate }}</label>
    <label class="col-sm-2"></label>
    <label *ngIf="isNotSmallSize"
           class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUNDLAGE_VORAUSZAHLUNGEN.ZU_VERSTEUERNDES_EINKOMMEN' | translate }}</label>
  </div>
  <div class="form-row justify-content-between">
    <label class="d-sm-none col-form-label" for="zuVerstEink">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUENDUNGSJAHR' | translate }}
    </label>
    <div class="col-sm-5">
      <input class="form-control text-right pr-3x" datevMessagePath="zuVerstEink{{objectId}}" formControlName="zuVerstEink"
             id="zuVerstEink" type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>
    <label class="d-sm-none col-form-label" for="zuVerstEinkFj">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.FOLGEJAHR' | translate }}
    </label>
    <div class="col-sm-5">
      <input class="form-control text-right pr-3x" datevMessagePath="zuVerstEinkFj{{objectId}}" formControlName="zuVerstEinkFj"
             id="zuVerstEinkFj"
             type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>
  </div>

  <div class="form-row">
    <label
      class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUNDLAGE_VORAUSZAHLUNGEN.STEUERANRECHNUNGSBETRAEGE' | translate }}</label>
    <label class="col-sm-2"></label>
    <label *ngIf="isNotSmallSize"
           class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUNDLAGE_VORAUSZAHLUNGEN.STEUERANRECHNUNGSBETRAEGE' | translate }}</label>
  </div>
  <div class="form-row justify-content-between">
    <label class="d-sm-none col-form-label" for="stAnrBetr">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUENDUNGSJAHR' | translate }}
    </label>
    <div class="col-sm-5">
      <input class="form-control text-right pr-3x" datevMessagePath="stAnrBetr{{objectId}}" formControlName="stAnrBetr"
             id="stAnrBetr" type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>
    <label class="d-sm-none col-form-label" for="stAnrBetrFj">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.FOLGEJAHR' | translate }}
    </label>
    <div class="col-sm-5">
      <input class="form-control text-right pr-3x" datevMessagePath="stAnrBetrFj{{objectId}}" formControlName="stAnrBetrFj"
             id="stAnrBetrFj"
             type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>
  </div>

  <div class="form-row">
    <label
      class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUNDLAGE_VORAUSZAHLUNGEN.GEWERBEERTRAG' | translate }}</label>
    <label class="col-sm-2"></label>
    <label *ngIf="isNotSmallSize"
           class="col-form-label col-sm-5">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUNDLAGE_VORAUSZAHLUNGEN.GEWERBEERTRAG' | translate }}</label>
  </div>
  <div class="form-row justify-content-between">
    <label class="d-sm-none col-form-label" for="gewerbeertrag">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.GRUENDUNGSJAHR' | translate }}
    </label>
    <div class="col-sm-5">
      <input class="form-control text-right pr-3x" datevMessagePath="gewerbeertrag{{objectId}}" formControlName="gewerbeertrag"
             id="gewerbeertrag" type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>
    <label class="d-sm-none col-form-label" for="gewerbeertragFj">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_ANGABEN.FOLGEJAHR' | translate }}
    </label>
    <div class="col-sm-5">
      <input class="form-control text-right pr-3x" datevMessagePath="gewerbeertragFj{{objectId}}" formControlName="gewerbeertragFj"
             id="gewerbeertragFj"
             type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>
  </div>

</form>
